"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("@airasia/phoenix-components/components/Button"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _calendar = require("../calendar.utilities");

var _calendarfooter = _interopRequireDefault(require("./calendarfooter.proptypes"));

var _constant = require("../constant");

var CalendarFooter = _styledComponents.default.div.withConfig({
  displayName: "calendarfooter__CalendarFooter",
  componentId: "sc-1pqsoxb-0"
})(["display:flex;flex-direction:row;background-color:", ";border-width:1px;border-color:", ";padding:", ";border-style:solid;border-top:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.default;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.greyMedium;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.small;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.none;
});

var FooterElements = _styledComponents.default.div.withConfig({
  displayName: "calendarfooter__FooterElements",
  componentId: "sc-1pqsoxb-1"
})(function (_ref5) {
  var justifyEnd = _ref5.justifyEnd;
  return "\n    display: flex;\n    flex: 1;\n\n    ".concat(justifyEnd ? "justify-content: flex-end;" : '', "\n  ");
});

var FooterLabel = _styledComponents.default.div.withConfig({
  displayName: "calendarfooter__FooterLabel",
  componentId: "sc-1pqsoxb-2"
})(function (_ref6) {
  var ismobile = _ref6.ismobile;
  return "\n    ".concat(ismobile ? "\n          position: relative;\n          top: -6px;\n        " : '', "\n  ");
});

var FooterButton = _styledComponents.default.div.withConfig({
  displayName: "calendarfooter__FooterButton",
  componentId: "sc-1pqsoxb-3"
})(function (_ref7) {
  var ismobile = _ref7.ismobile;
  return "\n    display: flex;\n    flex: 1;\n    flex-direction: row;\n    align-items: center;\n    flex: 2;\n    justify-content: ".concat(ismobile ? 'center' : 'flex-start', ";\n\n    ").concat(ismobile ? "\n          flex-direction: column;\n        " : '', "\n  ");
});

var FooterButtonItem = _styledComponents.default.div.withConfig({
  displayName: "calendarfooter__FooterButtonItem",
  componentId: "sc-1pqsoxb-4"
})(["a{height:22px;}"]);

var AaCalendarFooter = function AaCalendarFooter(props) {
  var viewType = props.viewType,
      disableButtons = props.disableButtons,
      buttonsConfig = props.buttonsConfig,
      confirmLabel = props.confirmLabel,
      resetLabel = props.resetLabel,
      lowestFareLabel = props.lowestFareLabel,
      noFareLabel = props.noFareLabel,
      isFareLoaded = props.isFareLoaded,
      currency = props.currency,
      theme = props.theme,
      onBlur = props.onBlur,
      isPartialHotelCalendar = props.isPartialHotelCalendar;
  var confirmBtnStyle = buttonsConfig.confirm.style || {
    backgroundColor: 'primary'
  };
  var customProperties = isPartialHotelCalendar ? {
    id: 'partialHotelClosebutton'
  } : {
    id: 'closebutton'
  };
  return /*#__PURE__*/_react.default.createElement(CalendarFooter, null, /*#__PURE__*/_react.default.createElement(FooterButton, {
    id: isPartialHotelCalendar && 'partialHotelFooter' || 'footer',
    ismobile: viewType === _constant.MOBILE
  }, currency && /*#__PURE__*/_react.default.createElement(FooterElements, null, /*#__PURE__*/_react.default.createElement(FooterLabel, {
    ismobile: viewType === _constant.MOBILE
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "small",
    color: "greyDark",
    theme: theme
  }, isFareLoaded ? _calendar.AaCalendarUtilities.formatString(lowestFareLabel, [currency]) : noFareLabel))), /*#__PURE__*/_react.default.createElement(FooterElements, {
    justifyEnd: true
  }, /*#__PURE__*/_react.default.createElement(FooterButtonItem, {
    style: {
      minHeight: 48,
      marginRight: 16
    }
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    border: disableButtons ? 'greyLight' : 'primary',
    paddingLeft: "40px",
    paddingRight: "40px",
    handleClick: !disableButtons ? buttonsConfig.reset.controls.onButtonPress : null,
    disabled: disableButtons
  }, resetLabel)), /*#__PURE__*/_react.default.createElement(FooterButtonItem, {
    style: {
      minHeight: 48
    },
    onBlur: onBlur
  }, /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
    customProperties: customProperties,
    disabled: disableButtons,
    color: "default",
    paddingLeft: "40px",
    paddingRight: "40px",
    handleClick: !disableButtons ? buttonsConfig.confirm.controls.onButtonPress : null
  }, confirmBtnStyle), confirmLabel)))));
};

AaCalendarFooter.propTypes = _calendarfooter.default.PropTypes;
AaCalendarFooter.defaultProps = _calendarfooter.default.DefaultProps;
var _default = AaCalendarFooter;
exports.default = _default;